<div class="form-group row mb-1" #formGroupRef>
    <label *ngIf="label" [attr.for]="label | monRemoveWhiteSpace" class="col-sm-8 col-form-label text-bold capitalize-first-letter text-right">
        {{ label }}<span *ngIf="ngRequired || required">*</span>
    </label>
    <div [ngClass]="{'col-sm-40' : label, 'col-sm-48': !label }">
        <input
            [ngModel]="value"
            (ngModelChange)="onValueChange($event)"
            [name]="'input-' + (label | monRemoveWhiteSpace)"
            [attr.data-test]="'input-' + (label | e2eAttributeEncoding)"
            [attr.type]="type"
            [class]="'form-control ' + (isFieldValid() ? '' : 'is-invalid')"
            [attr.id]="label | monRemoveWhiteSpace"
            [attr.autocomplete]="autocomplete"
            [attr.placeholder]="placeholder"
            [disabled]="disabled"
            [attr.min]="min"
            [attr.max]="max"
            (blur)="onInputBlur()"
            [required]="required"
        />
        <span class="form-text text-muted">{{ helpTxt }}</span>
    </div>
</div>
